import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';
import { RoleEnum } from '/@/enums/roleEnum';
import { PermissionCodeEnum } from '/@/enums/permissionCodeEnum';

const recents: AppRouteModule = {
  path: RouteEnum.TEAM,
  name: RouteEnum.TEAM,
  component: LAYOUT,
  redirect: RouteEnum.TEAM_MANAGEMENT,
  meta: {
    hideChildrenInMenu: true,
    icon: 'ant-design:team-outlined',
    title: t('routes.team.team'),
    orderNo: 30,
    // hideMenu: true,
    roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
    permCode: [
      PermissionCodeEnum.TEAM_MEMBER_QUERY,
      PermissionCodeEnum.TEAM_GROUP_QUERY,
      PermissionCodeEnum.TEAM_ROLE_QUERY,
      PermissionCodeEnum.TEAM_BILLING_VIEW,
      PermissionCodeEnum.TEAM_PARTNER_VIEW,
      PermissionCodeEnum.CLOUD_STORAGE_VIEW,
      PermissionCodeEnum.TEAM_COMMENTTYPE_VIEW,
    ],
  },
  children: [
    {
      path: 'management',
      name: RouteEnum.TEAM_MANAGEMENT,
      component: () => import('/@/views/team/management/index.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
        // hideBreadcrumb: false,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
    {
      path: 'billing',
      name: RouteEnum.TEAM_BILLING,
      component: () => import('/@/views/team/billing/index.vue'),
      meta: {
        title: t('routes.team.team'),
        // affix: true,
        hideMenu: true,
        // hideBreadcrumb: false,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
    {
      path: 'api',
      name: RouteEnum.TEAM_API,
      component: () => import('/@/views/team/api/index.vue'),
      meta: {
        title: t('routes.team.team'),
        // affix: true,
        hideMenu: true,
        // hideBreadcrumb: false,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
    {
      path: 'comments',
      name: RouteEnum.TEAM_COMMENTS,
      component: () => import('/@/views/team/comments/index.vue'),
      meta: {
        title: t('routes.team.team'),
        // affix: true,
        hideMenu: true,
        // hideBreadcrumb: false,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
    {
      path: 'storage',
      name: RouteEnum.TEAM_STORAGE,
      component: () => import('/@/views/team/storage/index.vue'),
      meta: {
        title: t('routes.team.team'),
        // affix: true,
        hideMenu: true,
        // hideBreadcrumb: false,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
    {
      path: 'setting',
      name: RouteEnum.TEAM_SETTING,
      component: () => import('/@/views/team/setting/index.vue'),
      meta: {
        title: t('routes.team.team'),
        // affix: true,
        hideMenu: true,
        // hideBreadcrumb: false,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
    {
      path: 'groupInfo',
      name: RouteEnum.TEAM_GROUP_INFO,
      component: () => import('/@/views/team/management/Group/info/index.vue'),
      meta: {
        title: t('routes.team.group'),
        // affix: true,
        hideMenu: true,
        // hideBreadcrumb: false,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
    {
      path: 'paySuccess',
      name: RouteEnum.TEAM_PAY_SUCCESS,
      component: () => import('/@/views/team/billing/result/BillingSuccess.vue'),
      meta: {
        title: t('routes.team.team'),
        // affix: true,
        hideMenu: true,
        hideBreadcrumb: true,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
    {
      path: 'payFailed',
      name: RouteEnum.TEAM_PAY_FAILED,
      component: () => import('/@/views/team/billing/result/BillingFailed.vue'),
      meta: {
        title: t('routes.team.team'),
        // affix: true,
        hideMenu: true,
        hideBreadcrumb: true,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
    {
      path: 'subscriptionSuccess',
      name: RouteEnum.TEAM_SUBSCRIPTION_SUCCESS,
      component: () => import('/@/views/team/billing/result/BillingSubscription.vue'),
      meta: {
        title: t('routes.team.team'),
        // affix: true,
        hideMenu: true,
        hideBreadcrumb: true,
        currentActiveMenu: RouteEnum.TEAM_MANAGEMENT,
        roles: [RoleEnum.TEAMOWNER, RoleEnum.ADMIN],
      },
    },
  ],
};

export default recents;
